import type { OemPartnerGroupDto } from '@evimo/client/models';

export type OemRateTableRow = {
  key: string;
  relationshipId: string;
  partnerName: string;
  partnerRowSpan: number;
  windowValue: number | null;
  windowUnit: string | null;
  costAmount: number | null;
  currency: string | null;
};

export function buildOemRateTableRows(
  groups: OemPartnerGroupDto[],
): OemRateTableRow[] {
  return groups.flatMap((group): OemRateTableRow[] => {
    const rateEntries = group.slaContract?.rateEntries ?? [];

    if (rateEntries.length === 0) {
      return [
        {
          key: `${group.relationshipId}-empty`,
          relationshipId: group.relationshipId,
          partnerName: group.partnerName,
          partnerRowSpan: 1,
          windowValue: null,
          windowUnit: null,
          costAmount: null,
          currency: null,
        },
      ];
    }

    return rateEntries.map((rate, index) => ({
      key: `${group.relationshipId}-${rate.id}`,
      relationshipId: group.relationshipId,
      partnerName: group.partnerName,
      partnerRowSpan: index === 0 ? rateEntries.length : 0,
      windowValue: rate.windowValue,
      windowUnit: rate.windowUnit,
      costAmount: rate.costAmount,
      currency: rate.currency ?? null,
    }));
  });
}
